<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Income Statement Analysis By Dimension
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="3">
                <b-form-group label-cols=3 label="Line Layout">
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" ></b-form-select>
                </b-form-group>
                </b-col>
                <b-col lg="3">
                    <b-form-group label-cols=5 label="Dimension as Row">
                        <b-form-select v-model="filter.DimRow" :plain="true" :options="dimension"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3">
                    <b-form-group label-cols=5 label="Dimension as Coloum">
                        <b-form-select v-model="filter.DimCol" :plain="true" :options="dimension"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3">
                <b-form-group label-cols=3 label="Periode Date">
                    <b-row>
                        <b-col class="pr-1" cols="6"><b-form-input v-model="filter.tgl1" type="date" placeholder="from date" readonly></b-form-input></b-col>
                        <b-col class="pl-1" cols="6"><b-form-input v-model="filter.tgl2" type="date" placeholder="until date" @change="updateTgl1"></b-form-input></b-col>
                    </b-row>                      
                </b-form-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th >Description</th>
                            <th style="text-align:right" width="100px" v-for="kol in rptPnl.koloms" :key="kol.kode">{{kol.nama}}</th>
                            <th style="text-align:right" width="110px">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptPnl.lines" :key="row.idrowunik">
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-for="kol in rptPnl.koloms" :key="kol.kode" style="text-align:right">
                                <span v-if="row.kode || row.rumus">{{row[`K${kol.kode.trim()}`] | numFormat("0,0.00") }}</span>
                            </td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillMonToDate(row)" style="text-align:right">
                                {{row.total | numFormat("0,0.00") }}
                            </td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import incomestat from "../../apis/incomestat";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        DimRow: { required },
        DimCol: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {DimRow: '',DimCol: '',layout:'',tgl1:'',tgl2:''},
      isLoading: false,
      layouts:[],
      horizontal: true,
      dimension:[],
      reportUrl: null,
      showReport:false,
      rptPnl:{lines:[], koloms:[]}
    };
  },
components: { Loading },  
computed:{
    dimCol() {
        return this.filter.DimCol;
    },
    dimRow() {
        return this.filter.DimRow;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      dimCol: function(newval) {
          this.filter.DimColInfo=this.dimension.find(d => d.value === newval).text;
      },
      dimRow: function(newval) {
          this.filter.DimRowInfo=this.dimension.find(d => d.value === newval).text;
      },
      layout: async function(newval) {
          this.rptPnl.lines= await incomestat.layout({layout : newval});
      }
  },
created: async function (){
     this.layouts = await incomestat.layout_combo();
     this.dimension=this.$store.state.dimension.reduce((newArr,item) =>{
         newArr.push(item);
         return newArr;
     },[]);
     this.dimension.push({ value: 'periode', text: 'Periode' });
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    // this.filter.DimCol=this.dimension[0].value;
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                let arrRes = await incomestat.pnldimanalys(model);
                this.rptPnl.lines=arrRes[0];
                this.rptPnl.koloms=arrRes[1];
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await incomestat.pnldimanalysprint(model);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },

    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                const response = await incomestat.pnldimanalysexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    close(){
      router.push("home");
    }
  }
};
</script>
